import React, { useState } from 'react';
import styled from 'styled-components';

const GLOSSARY_SRC = `${process.env.PUBLIC_URL || ''}/glossary/index.html`;

export default function Glossary() {
  const [loading, setLoading] = useState(true);

  return (
    <Div>
      {loading && <div className="gl__loading">Opening glossary.exe…</div>}
      <iframe
        src={GLOSSARY_SRC}
        title="glossary.exe"
        className="gl__iframe"
        onLoad={() => setLoading(false)}
      />
    </Div>
  );
}

const Div = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  overflow: hidden;
  background: #ece9d8;
  font-family: Tahoma, sans-serif;

  .gl__iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
  .gl__loading {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    color: #333;
    background: #ece9d8;
    z-index: 1;
  }
`;
